<template>
  <header class="sticky top-0 z-50 bg-white/80 backdrop-blur-md ring-1 ring-gray-100">
    <navigation-desktop @open="onMobileMenuClicked" />

    <navigation-mobile
      :opened="isMobileMenuOpened"
      @close="onMobileMenuClicked"
    />
  </header>
</template>

<script setup lang="ts">
const isMobileMenuOpened = ref<boolean>(false)

function onMobileMenuClicked (isMenuOpened: boolean) {
  isMobileMenuOpened.value = isMenuOpened
}
</script>
